import { DELETE_COMMENT } from 'root/src/client/logic/comment/actionIds'

export default payload => ({
	type: DELETE_COMMENT,
	payload,
})
